<template>
  <div class="wrapper" >
    <div class="alerta amber lighten-2 center-align" v-show="mostrarAlerta">
      {{ mensajeAlerta }}
    </div>


    <div id="verificationCode" class="modal modal-code" >
      <div class="modal-content" >
        <div class=" center-align quitar-padding" style="padding: 1.3rem" >
            <span class="page-title">
              Código de verificación
            </span>
          <div class="color-card" style="backgroundColor: rgba(0,0,0,0);">
            <form @submit.prevent="enviarCodigo">
              <div class="input-field col s12  m10 offset-m1">
                <i class="material-icons prefix">https</i>
                <input id="input-codegoogle" type="text" v-model="googleCode">
                <label for="input-codegoogle">Código de verificación</label>
              </div>

              <button type="submit" class="waves-effect waves-light btn boton-personalizado blue-grey darken-3"
                      :style="{'background-color': accentColor}">Enviar
              </button>
            </form>
          </div>
        </div>
        <div
            class=" waves-effect waves-light tooltipped  "
            @click="cerrarModal"
            style="position: absolute;
          right: -0.5%;
          top: -2.5%;
          z-index: 1022;
          padding: 7px !important;
          color: #9C2626;
          border: 2px

         "
            data-position="bottom"
            data-tooltip="Cancelar"
        >
          <link
              rel="stylesheet"
              href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0"
          />
          <span class="material-symbols-outlined btn-style" style="font-size: 40px;">
            cancel
          </span>
        </div>
      </div>
    </div>

    <div class="row personalize-theme">
      <div>
<!--        <a-->
<!--          @click="pushing('recargas')"-->
<!--          asdasd-->
<!--          :style="`color: ${primaryColor} !important`"-->
<!--        >-->
<!--        </a>-->
        <a
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
          data-target="slide-out"
          class=" sidenav-trigger  waves-effect "
          style="top:10px; margin-left: 1rem;"
        >
          <span
            class="material-symbols-outlined jello-horizontal"
            style="font-size: 35px !important;"
          >
            menu
          </span>
        </a>

        <ul id="slide-out" class="sidenav scale-in-left ">
          <li>
            <div class="user blue-grey darken-3" style="color: white;">
              <link
                rel="stylesheet"
                href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
              />

              <span
                class="material-symbols-outlined"
                style="color:white;"
              >
                account_circle
              </span>
              {{ nombreUsuario }}

            </div>
          </li>

          <img
            class="logo"
            :src="
              dominioI === 'zaz' ? 'https://recarga-te.com/dist/zaz.jpg' : image
            "
          />
          <!--           <li>
            <div class="user-view">
              <div class="background">
                <img :src="backgroundImage" />
              </div>
              <a href="#user"><img class="circle" :src="profileImage"/></a>
              <a href="#name"
                ><span class="white-text name">{{ nombreUsuario }}</span></a
              >
              <a href="#email"
                ><span class="white-text email">{{ correoUsuario }}</span></a
              >
            </div>
          </li> -->

          <li v-if="fIsControler('recargas')">
            <a
              @click="pushing('recargas')"
              :style="`color: ${primaryColor} !important`"
            >
              <link
                rel="stylesheet"
                href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,0,0"
              />
              <span class="material-symbols-outlined">
                security_update_good
              </span>
              Recargar</a
            >
          </li>
          <li v-if="isAdmin && fIsControler('usuarios')" >
            <a
              @click="pushing('usuarios')"
              :style="`color: ${primaryColor} !important`"
            >
              <link
                rel="stylesheet"
                href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,0,0"
              />
              <span class="material-symbols-outlined">
                group
              </span>
              Usuarios</a
            >
          </li>
          <li v-if="permisos.includes('USUARIO_CLIENTE') && miNivel === '2' && fIsControler('usuarios')" >
            <a
              @click="pushing('usuarios')"
              :style="`color: ${primaryColor} !important`"
              ><link
                rel="stylesheet"
                href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,0,0"
              />
              <span class="material-symbols-outlined"> groups </span>Mis
              clientes</a
            >
          </li>
          <li v-if="fIsControler('ventas')">
            <a
              @click="pushing('ventas')"
              :style="`color: ${primaryColor} !important`"
            >
              <link
                rel="stylesheet"
                href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,0,0"
              />
              <span class="material-symbols-outlined">
                storefront
              </span>
              Ventas</a
            >
          </li>

          <li v-if="canUpload && fIsControler('subirArchivos')" >
            <a
              @click="pushing('subirArchivos')"
              :style="`color: ${primaryColor} !important`"
            >
              <link
                rel="stylesheet"
                href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,0,0"
              />
              <span class="material-symbols-outlined">
                note_add
              </span>
              Subir archivos</a
            >
          </li>
          <li v-if="isRecicladoMasivo && fIsControler('recicladoMasivo')" >
            <a
                @click="pushing('recicladoMasivo')"
                :style="`color: ${primaryColor} !important`"
            >
              <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0&icon_names=recycling" />
                <span class="material-symbols-outlined">
                recycling
                </span>
              Reciclado Masivo</a
            >
          </li>
          <li v-if="fIsControler('administrarBase')">
            <a
              @click="pushing('administrarBase')"
              :style="`color: ${primaryColor} !important`"
            >
              <link
                rel="stylesheet"
                href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,0,0"
              />
              <span class="material-symbols-outlined">
                database
              </span>
              Administrar base de datos</a
            >
          </li>
          <li v-if="isRecargaMasiva && fIsControler('recargasMasivas')" >
            <a
              @click="pushing('recargasMasivas')"
              :style="`color: ${primaryColor} !important`"
            >
              <link
                rel="stylesheet"
                href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,0,0"
              />
              <span class="material-symbols-outlined">
                add_to_home_screen
              </span>
              Recargas Masivas</a
            >
          </li>
          <li v-if="isPortabilidades && fIsControler('portabilidades')">
            <a
              @click="pushing('portabilidades')"
              :style="`color: ${primaryColor} !important`"
              ><link
                rel="stylesheet"
                href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,0,0"
              />
              <span class="material-symbols-outlined"> offline_share </span
              >Portabilidades</a
            >
          </li>
          <li v-if="isGraficas && fIsControler('graficas')" >
            <a
              @click="pushing('graficas')"
              :style="`color: ${primaryColor} !important`"
            >
              <link
                rel="stylesheet"
                href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,0,0"
              />
              <span class="material-symbols-outlined">
                insert_chart
              </span>
              Gráficas</a
            >
          </li>
          <li v-if="isInventoryDays && fIsControler('inventario')" >
            <a
              @click="pushing('inventario')"
              :style="`color: ${primaryColor} !important`"
              ><link
                rel="stylesheet"
                href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,0,0"
              />
              <span class="material-symbols-outlined">
                inventory
              </span>
              Inventario</a
            >
          </li>
          <li v-if="recargasCarier && fIsControler('recargasCarier')" >
            <a
              @click="pushing('recargasCarier')"
              :style="`color: ${primaryColor} !important`"
              ><link
                rel="stylesheet"
                href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,0,0"
              />
              <span class="material-symbols-outlined">
                cell_tower
              </span>
              Recargas por carrier</a
            >
          </li>
          <li v-if="recargasSinUsuario && miNivel == 1 && fIsControler('configRecargasSinUsuario')" >
            <a
              @click="pushing('configRecargasSinUsuario')"
              :style="`color: ${primaryColor} !important`"
              ><link
                rel="stylesheet"
                href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,0,0"
              />
              <span class="material-symbols-outlined"> device_unknown </span
              >Recargas sin usuario</a
            >
          </li>
          <li v-if="fIsControler('comentariosCarier')">
            <a
              v-if="false"
              @click="pushing('comentariosCarier')"
              :style="`color: ${primaryColor} !important`"
              ><link
                rel="stylesheet"
                href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,0,0"
              />
              <span class="material-symbols-outlined"> stream_apps </span
              >Comentarios por carrier</a
            >
          </li>
          <li>
            <a
                @click="pushing('actualizaciones')"
                :style="`color: ${primaryColor} !important;`"
            ><link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200" />
              <span class="material-symbols-outlined" >
                update </span
              >Actualizaciones <span class=" badge " :style="`background-color: ${primaryColor} !important; color: white;`" >Nuevo</span></a
            >

          </li>
          <li>
            <a
              @click="cerrarSesion"
              :style="`color: ${primaryColor} !important; margin-top:50px`"
              ><link
                rel="stylesheet"
                href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
              />
              <span class="material-symbols-outlined" style="color: #FF3333">
                logout </span
              >Cerrar Sesión</a
            >
          </li>
        </ul>
      </div>
      <router-view v-slot="{ Component, route }" class="contenedor-principal">
        <transition name="fade">
          <component :is="Component" />
        </transition>
      </router-view>
    </div>
  </div>
</template>

<script>
import { quienSoy, getSaldos, getPermisos, renuevaToken } from "@/api/api";
import { mapState } from "vuex";
import { permisos, controles } from "@/constantes";
import { emitter } from '@/eventBus';
import {onBeforeUnmount} from 'vue'

export default {
  name: "navbar",
  data() {
    return {
      nombreUsuario: "",
      empresa: '',
      username: '',
      isControler: false,
      isAsec: true,
      mensajeAlerta: "",
      mostrarAlerta: false,
      isAdmin: false,
      isRecargaMasiva: false,
      miNivel: "3",
      classChange: "change",
      classExpand: true,
      canUpload: false,
      isGraficas: false,
      isRecicladoMasivo: false,
      isPortabilidades: false,
      isInventoryDays: false,
      recargasCarier: false,
      dominioI: "",
      recargasSinUsuario: localStorage.recargaSinUsuario == 0 ? false : true,
      googleCode: '',
      latitude: '',
      longitude: '',
      modalEvent: '',
      listenerRegistered: false
    };
  },
  //computed:{
  //  arregloActivos(){
  //    let arregloAux = [false, false, false]
  //    arregloAux[this.activo]=true
  //    return arregloAux
  //  }
  //},
  methods: {
    enviarCodigo(){
      this.cerrarModal()
      emitter.emit('enviarCodigo',{
        googleCode: this.googleCode,
        latitude: this.latitude,
        longitude: this.longitude,
        event: this.modalEvent
      })
    },

    showModal(event){
      console.log(`mostrando modal`)

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(async position => {
          const latitude = position.coords.latitude;
          const longitude = position.coords.longitude;
          navigator.permissions.query({name: 'geolocation'}).then(result => {
            if (result.state === 'granted') {
              this.latitude = latitude
              this.longitude = longitude
              this.googleCode = ''
              setTimeout(() => $("#verificationCode").modal("open"), 60);
            } else if (result.state === 'prompt') {
              Promise.reject({mensaje: 'Activa los permisos de ubucacion'})
            } else if (result.state === 'denied') {
              Promise.reject({mensaje: 'Activa los permisos de ubucacion'})
            }
          })
        }, error => {
          console.error('Error al obtener la ubicación:', error.message);
          this.msg =  'Por favor activa los permisos de ubicación antes de continuar'
        });
      } else {
        alert('Geolocalización no soportada por este navegador.');
      }
    },



    cerrarModal(){

      setTimeout(() => $("#verificationCode").modal("close"), 1);
    },
    fIsControler(ruta){

      const empresa =  controles[`${this.empresa}`]
      if(!empresa) return true
      const user = empresa.find( e =>  e.user == this.username)
      if(!user) return true
      const rutaValida = user.rutas.find( r =>  r == ruta)
      if(rutaValida) return true

      return false
    },
    // toggleHamburguer() {
    //   this.classChange = !this.classChange;
    // },
    pushing(name) {
      console.log("eeee");
      M.Sidenav.getInstance(document.getElementById("slide-out")).close();
      this.$router.push({ name });
      if (window.innerWidth <= 800) this.toggleHamburguer();
    },
    cerrarSesion() {
      M.Sidenav.getInstance(document.getElementById("slide-out")).close();
      const auxEmpresa = localStorage.empresa;
      localStorage.removeItem("token");
      localStorage.removeItem("nivel");
      localStorage.removeItem("id");
      localStorage.removeItem("nombre");
      localStorage.removeItem("empresa");
      localStorage.removeItem("permisos");
      localStorage.removeItem("recargaSinUsuario");
      this.$router.push({ name: "login", params: { empresa: auxEmpresa } });
    },
    toggleHamburguer() {
      if (this.classChange === "change") {
        this.classChange = "";
        this.classExpand = "";
      } else {
        this.classChange = "change";
        this.classExpand = true;
      }
    },
    widthEvent() {
      if (window.innerWidth <= 800) {
        this.classChange = "";
        this.classExpand = "";
      } else {
        this.classChange = "change";
        this.classExpand = true;
      }
    },
  },

  created() {
    const dominio = window.location.href;
    window.addEventListener("resize", this.widthEvent);
    this.widthEvent();
    if (!localStorage.token) return this.$router.push({ name: "login" });
    this.nombreUsuario = localStorage.nombre;
    this.username = localStorage.username;
    this.empresa = localStorage.empresa;
    if (dominio.includes("recargasasec.com")) this.isAsec = false;
    this.isAdmin = localStorage.nivel === "1" || localStorage.nivel === "0";
    this.miNivel = localStorage.nivel + "";
    this.$store.commit("setAdmin", this.isAdmin);
    this.isRecargaMasiva =
      (localStorage.getItem("permisos") + "").includes(
        permisos.RECARGAS_MASIVAS
      ) && this.isAdmin;
    this.isGraficas =
      (localStorage.getItem("permisos") + "").includes(permisos.GRAFICAS) &&
      this.isAdmin;
    this.isRecicladoMasivo =
      (localStorage.getItem("permisos") + "").includes(permisos.RECICLADO_MASIVO) &&
      this.isAdmin;
    this.isPortabilidades =
      (localStorage.getItem("permisos") + "").includes(
        permisos.PORTABILIDADES
      ) && this.isAdmin;
    this.isInventoryDays =
      (localStorage.getItem("permisos") + "").includes(permisos.INVENTARIO) &&
      this.miNivel != 3;
    this.recargasCarier =
      (localStorage.getItem("permisos") + "").includes(
        permisos.RECARGAS_CARRIER
      ) && this.miNivel == 1;
    this.canUpload =
      this.isAdmin ||
      (
          (localStorage.getItem("permisos") + "").includes( permisos.RETROALIMENTACION_LIDER) &&
        this.miNivel !== "3"
      );



  },
  beforeDestroy() {
    console.log(`asdasdasda`)
    console.log( `asdasdasda`)
    // this.$nextTick(()=>{
    //   console.log(this.listenerRegistered, `se apagago em emiter`)
    //   window.removeEventListener("resize", this.widthEvent);
    //   this.listenerRegistered = false
    //   emitter.off('showModal')
    //   console.log(this.listenerRegistered, `se apagago em emiter`)
    // })
  },
  mounted() {

    this.$nextTick(()=>{
      if(!this.listenerRegistered){
        emitter.on('showModal', (data) => {
          console.log(`aqui entra`)
          this.modalEvent = data ? data.event : ''
          this.showModal()
        });
        this.listenerRegistered = true;
      }
    })

    M.AutoInit();
    const dominio = window.location.href;
    if (dominio.includes("recargaszaz.com.mx")) this.dominioI = "zaz";
    localStorage.removeItem("permisos");
    getPermisos()
      .then((response) => {
        console.log("estoy en permisos");
        localStorage.setItem("permisos", response.permisos.join("-"));
        this.$store.commit("setPermisos", response.permisos.join("-"));
        this.isRecargaMasiva =
          this.isAdmin && this.permisos.includes(permisos.RECARGAS_MASIVAS);
        this.isGraficas =
          this.isAdmin && this.permisos.includes(permisos.GRAFICAS);
        this.isRecicladoMasivo =
          this.isAdmin && this.permisos.includes(permisos.RECICLADO_MASIVO);
        this.isPortabilidades =
          this.isAdmin && this.permisos.includes(permisos.PORTABILIDADES);
        this.isInventoryDays =
          this.miNivel != 3 && this.permisos.includes(permisos.INVENTARIO);
        this.recargasCarier =
          this.miNivel == 1 &&
          this.permisos.includes(permisos.RECARGAS_CARRIER);
        this.canUpload =
          this.isAdmin ||
          (this.permisos.includes(permisos.RETROALIMENTACION_LIDER) &&
            this.miNivel !== "3");

      })
      .catch((error) => {
        console.log(error);
        if (
          (error.message && error.message.includes("Token expirado")) ||
          error.mensaje.includes("Token expirado")
        ) {
          renuevaToken()
            .then((response) => {
              localStorage.token = response.token;
            })
            .catch((error) => console.log(error));
        }
        if (
          error.message === "el token NO es valido" ||
          error.mensaje === "el token NO es valido"
        )
          return this.$router.push({ name: "login" });
        console.log(error);
      });
    if (!localStorage.token) return this.$router.push({ name: "login" });
    this.nombreUsuario = localStorage.nombre;
    this.isAdmin = localStorage.nivel === "1" || localStorage.nivel === "0";
    this.miNivel = localStorage.nivel + "";
    this.$store.commit("setAdmin", this.isAdmin);
    this.isRecargaMasiva =
      (localStorage.getItem("permisos") + "").includes(
        permisos.RECARGAS_MASIVAS
      ) && this.isAdmin;
    this.isPortabilidades =
      this.isAdmin &&
      (localStorage.getItem("permisos") + "").includes(permisos.PORTABILIDADES);
    this.isInventoryDays =
      (localStorage.getItem("permisos") + "").includes(permisos.INVENTARIO) &&
      this.miNivel != 3;
    this.recargasCarier =
      (localStorage.getItem("permisos") + "").includes(
        permisos.RECARGAS_CARRIER
      ) && this.miNivel == 1;
    this.isGraficas =
      (localStorage.getItem("permisos") + "").includes(permisos.GRAFICAS) &&
      this.isAdmin;
    this.isRecicladoMasivo =
      (localStorage.getItem("permisos") + "").includes(permisos.RECICLADO_MASIVO) &&
      this.isAdmin;
    this.canUpload =
      this.isAdmin ||
      ((localStorage.getItem("permisos") + "").includes(
        permisos.RETROALIMENTACION_LIDER
      ) &&
        this.miNivel !== "3");


    if (!localStorage.nombre || !localStorage.nivel) {
      quienSoy()
        .then((respuesta) => {
          if (!respuesta.id) return this.$router.push({ name: "login" });
          localStorage.setItem("nivel", respuesta.nivel);
          localStorage.setItem("id", respuesta.id);
          localStorage.setItem("nombre", respuesta.nombre);
          localStorage.setItem("lider", respuesta.lider);
          this.nombreUsuario = respuesta.nombre;
          this.isAdmin =
            localStorage.nivel === "1" || localStorage.nivel === "0";
          this.miNivel = localStorage.nivel + "";
          this.$store.commit("setAdmin", this.isAdmin);
          this.isRecargaMasiva =
            (localStorage.getItem("permisos") + "").includes(
              permisos.RECARGAS_MASIVAS
            ) && this.isAdmin;
          this.isGraficas =
            (localStorage.getItem("permisos") + "").includes(
              permisos.GRAFICAS
            ) && this.isAdmin;
          this.isRecicladoMasivo =
            (localStorage.getItem("permisos") + "").includes(
              permisos.RECICLADO_MASIVO
            ) && this.isAdmin;
          this.isInventoryDays =
            (localStorage.getItem("permisos") + "").includes(
              permisos.INVENTARIO
            ) && this.miNivel != 3;
          this.recargasCarier =
            (localStorage.getItem("permisos") + "").includes(
              permisos.RECARGAS_CARRIER
            ) && this.isAdmin;
          this.isPortabilidades =
            (localStorage.getItem("permisos") + "").includes(
              permisos.PORTABILIDADES
            ) && this.isAdmin;
          this.canUpload =
            this.isAdmin ||
            (localStorage.getItem("permisos") + "").includes(
              permisos.RETROALIMENTACION_LIDER
            ) &&
            this.miNivel !== "3";

        })
        .catch((error) => {
          console.log(error);
        });
    }
  },
  computed: {
    ...mapState(["image", "primaryColor", "backgroundColor", "permisos"]),
  },
  //,
  //props: {
  //  activo: {type: String, required: true}
  //}
};
</script>

<style scoped>




.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/*.fade-enter-to,*/
/*.fade-leave-from {*/
/*  opacity: 0;*/
/*}*/


.jello-horizontal:hover {
  -webkit-animation: jello-horizontal 0.9s both;
  animation: jello-horizontal 0.9s both;
}

@-webkit-keyframes jello-horizontal {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
  30% {
    -webkit-transform: scale3d(1.25, 0.75, 1);
    transform: scale3d(1.25, 0.75, 1);
  }
  40% {
    -webkit-transform: scale3d(0.75, 1.25, 1);
    transform: scale3d(0.75, 1.25, 1);
  }
  50% {
    -webkit-transform: scale3d(1.15, 0.85, 1);
    transform: scale3d(1.15, 0.85, 1);
  }
  65% {
    -webkit-transform: scale3d(0.95, 1.05, 1);
    transform: scale3d(0.95, 1.05, 1);
  }
  75% {
    -webkit-transform: scale3d(1.05, 0.95, 1);
    transform: scale3d(1.05, 0.95, 1);
  }
  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}
@keyframes jello-horizontal {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
  30% {
    -webkit-transform: scale3d(1.25, 0.75, 1);
    transform: scale3d(1.25, 0.75, 1);
  }
  40% {
    -webkit-transform: scale3d(0.75, 1.25, 1);
    transform: scale3d(0.75, 1.25, 1);
  }
  50% {
    -webkit-transform: scale3d(1.15, 0.85, 1);
    transform: scale3d(1.15, 0.85, 1);
  }
  65% {
    -webkit-transform: scale3d(0.95, 1.05, 1);
    transform: scale3d(0.95, 1.05, 1);
  }
  75% {
    -webkit-transform: scale3d(1.05, 0.95, 1);
    transform: scale3d(1.05, 0.95, 1);
  }
  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

.user {
  padding: 0 32px;
}
li {
  align-items: center;
  gap: 8px;
}

.material-symbols-outlined {
  display: inline-block;
  vertical-align: middle;
  line-height: 1;
  margin-right: 4px;
}
.menu-lateral {
  height: 100vh;
  width: 20%;
  background: white;
  margin-top: 0 !important;
  top: 0;
  position: fixed;
}
.menu-container {
  max-height: calc(100vh - 64px);
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #18a9dd #dfe9eb;
}
/* Chrome, Edge and Safari */
*::-webkit-scrollbar {
  width: 5px;
  width: 5px;
}
*::-webkit-scrollbar-track {
  border-radius: 19px;
  background-color: #dfe9eb;
}

*::-webkit-scrollbar-track:hover {
  background-color: #b8c0c2;
}

*::-webkit-scrollbar-track:active {
  background-color: #b8c0c2;
}

*::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: #18a9dd;
}

*::-webkit-scrollbar-thumb:hover {
  background-color: #18a9dd;
}

*::-webkit-scrollbar-thumb:active {
  background-color: #18a9dd;
}
.collection-item:hover {
  background-color: rgba(130, 130, 130, 0.3) !important;
}
.sidenav li > a {
  cursor: pointer !important;
}
.collection {
  margin: 0.5rem 0 0.5rem 0;
}

.collection-header:hover {
  background-color: #cfd8dc;
}

.alerta {
  width: 100%;
  height: 32px;
  font-size: 1.3em;
}

.contenedor-principal {
  width: 100%;
  margin-left: 0%;
}

.logo {
  max-width: 100%;
  padding: 20px;
}

.container-hamburguer {
  height: 0;
  width: 0;
  overflow: hidden;
}

.bar1,
.bar2,
.bar3 {
  width: 35px;
  height: 5px;
  margin: 6px 0;
  transition: 0.4s;
}

.change .bar1 {
  -webkit-transform: rotate(-45deg) translate(-9px, 6px);
  transform: rotate(-45deg) translate(-9px, 6px);
}

.change .bar2 {
  opacity: 0;
}

.change .bar3 {
  -webkit-transform: rotate(45deg) translate(-8px, -8px);
  transform: rotate(45deg) translate(-8px, -8px);
}

.modal-code {
  border-radius: 20px;
  width: auto !important;
  max-width: 50% !important;
  width: 35vw !important;
  overflow-y: inherit !important;
}

.boton-personalizado {
  min-width: 50%;
  margin-top: 15px;
  font-size: 1.2em;
  height: 40px;
  line-height: 40px;
  border: none;
}

@media (max-width: 800px) {
  .menu-lateral {
    height: auto;
    width: 100%;
    display: block;
    position: relative;
    overflow: hidden;
  }

  .container-hamburguer {
    display: inline-block;
    cursor: pointer;
    right: 10px;
    margin-top: 5px;
    position: absolute;
    height: auto;
    width: auto;
    overflow: visible;
  }

  .contenedor-principal {
    width: 100%;
    margin-left: 0;
    display: block;
    position: relative;
  }

  .logo {
    max-height: 46px;
    padding: 0;
  }

  .personalize-theme {
    display: block;
  }
  .modal-code {
    border-radius: 20px;
    width: auto !important;
    max-width: 90% !important;
    width: 90vw !important;
    overflow-y: inherit !important;
  }
}


</style>
